import { Component } from '@angular/core';
import { UtilService } from '../../shared/services/util.service';
import { ExcelService } from '../../shared/services/excel.service';
import { ApiService } from '../../shared/services/api.service';

@Component({
  standalone: false,
  selector: 'app-settlements',
  templateUrl: './settlements.component.html',
  styleUrl: './settlements.component.scss'
})
export class SettlementsComponent {
  placeHolder = 'DD/MM/YYYY';
  minStart: any;
  fromDate: any = null;
  toDate: any = null;
  type: any;
  excelData: any;
  excelFile: any;
  reconciliationData: any;

  constructor(private _util: UtilService,
    private _excel: ExcelService,
    private _apiService: ApiService
  ) {

  }

  onFromDate(event: any) {
    const vm = this;
    vm.minStart = vm._util.getMinFormat(event);
  }


  errorMessage: string = '';

  uploadExcel(event: any) {
    const vm = this;
    const file = event.target.files[0];
    if (file && !file.name.endsWith('.xlsx')) {
      vm.errorMessage = 'Only .xlsx files are supported';
      event.target.value = '';
      return;
    }
    vm.excelFile = file;
    vm.errorMessage = '';
  }

  onClear() {
    const vm = this;
    vm.fromDate = null;
    vm.toDate = null;
    vm.type = null;
    vm.excelData = null;
    vm.excelFile = null;
    vm.minStart = null;
    vm.reconciliationData = null;
    vm.errorMessage = '';
  }

  onSubmit() {
    const vm = this;
    vm.errorMessage = '';
    if (!vm.fromDate || !vm.toDate || !vm.type || !vm.excelFile) {
      return;
    }
    const formData = new FormData();
    const startEpoch = vm.fromDate?.year ? new Date(vm.fromDate.year, vm.fromDate.month - 1, vm.fromDate.day).getTime() : vm.fromDate;
    const endEpoch = vm.toDate?.year ? new Date(vm.toDate.year, vm.toDate.month - 1, vm.toDate.day).getTime() : vm.toDate;
    formData.append('startDate', startEpoch);
    formData.append('endDate', endEpoch);
    formData.append('type', vm.type);
    formData.append('file', vm.excelFile, vm.excelFile.name);
    vm._apiService.postData('/admin/excel-reconciliation', formData).subscribe({
      next: (res: any) => {
        if (res && !res.error) {
          vm.reconciliationData = res.data;
        } else {
          vm.errorMessage = res.message || 'Reconciliation failed';
        }
      },
      error: (err: any) => {
        vm.errorMessage = (err.error && err.error.message) || err.message || 'Reconciliation failed due to a server error';
      }
    });
  }

}
